import { render, staticRenderFns } from "./DocumentsDelete.vue?vue&type=template&id=14bf6730&scoped=true&"
import script from "./DocumentsDelete.vue?vue&type=script&lang=js&"
export * from "./DocumentsDelete.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsDelete.vue?vue&type=style&index=0&id=14bf6730&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bf6730",
  null
  
)

export default component.exports